import { render } from "./ChalanDetails.vue?vue&type=template&id=fcaeb5ce&scoped=true"
import script from "./ChalanDetails.vue?vue&type=script&lang=js"
export * from "./ChalanDetails.vue?vue&type=script&lang=js"

import "./ChalanDetails.vue?vue&type=style&index=0&id=fcaeb5ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcaeb5ce"]])

export default __exports__